module.exports = __webpack_public_path__ + "img/hemline_sweep.8024c94c.png";